const createAndConfirmPasswordRu = {
  'createPassword': {
    'passwordLabel': 'Пароль',
    'confirmPasswordLabel': 'Повторите пароль',
    'requirementsTitle': 'Пароль должен содержать:',
    'requirements': {
      'symbolsCount': '8 символов',
      'specialCharacters': '1 специальный символ',
      'numbers': '1 цифру',
      'letters': 'русские или латинские буквы',
      'lowerAndUpperCase': 'строчные и прописные буквы',
    },
    'errors': {
      'passwordNotMatch': 'Пароль не совпадает',
    },
  },
};

export default createAndConfirmPasswordRu;
